module.exports = __webpack_public_path__ + "static/img/jxkp01.b112c12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/jxkp01.png
// module id = BbQL
// module chunks = 37